import { shouldPolyfill } from '@formatjs/intl-locale/should-polyfill'
import { Platform } from 'react-native'

export async function loadPolyfills() {
  if (Platform.OS === 'ios' || Platform.OS === 'android' || shouldPolyfill()) {
    await import('@formatjs/intl-locale/polyfill')
    await import('@formatjs/intl-getcanonicallocales/polyfill')
    await import('@formatjs/intl-pluralrules/polyfill')
    await import('@formatjs/intl-pluralrules/locale-data/en')
    await import('@formatjs/intl-numberformat/polyfill')
    await import('@formatjs/intl-numberformat/locale-data/en')
  }
}
